import { getEnvVariable } from './env';
export const getStaticResourceFullPath = (resourcePath) => {
    const staticBasePath = getEnvVariable('REACT_APP_STATIC_BASE_PATH');
    return `${staticBasePath}${resourcePath}`;
};
